import React from 'react';
import { Result, Button } from 'antd';
import { LockOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Component that restricts access to admin users only
 * Shows an access denied message for non-admin users
 */
const AdminOnlyRoute = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Check if user is admin
  const isAdmin = user && user.role === 'Admin';

  if (!isAdmin) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page. Administrator privileges are required."
        icon={<LockOutlined style={{ color: '#ff4d4f' }} />}
        extra={
          <Button 
            type="primary" 
            icon={<HomeOutlined />}
            onClick={() => navigate('/dashboard')}
          >
            Back to Dashboard
          </Button>
        }
      />
    );
  }

  // User is admin, render children
  return children;
};

export default AdminOnlyRoute;
